import userContextService from "@/app/shared/services/userContextService";

const appServices = class {
  async start() {
    await userContextService.start();
  }
};

export default new appServices();
